import React from "react";
import { oneProfileSetup } from "@one-profile/core";
import { accountProfileActivation } from "./account-profile-activation";
import Root from "./root";

const accountProfileSetup = oneProfileSetup(Root, {
  activationFn: accountProfileActivation,
});
export const { bootstrap, mount, unmount, config } = accountProfileSetup;
